export enum UserRole {
  SUPER_ADMIN = 'SUPER_ADMIN',
  ADMIN = 'ADMIN',
  CASHIER = 'CASHIER',
  FINANCE = 'FINANCIAL',
  USER = 'USER',
  STANDARD = 'STANDARD',
  PASSENGER = 'PASSENGER'
}

export type UserRoleType = keyof typeof UserRole;